import React from 'react';
import {Button} from 'react-native-paper';
import {requestAccounts} from '../../api/metamask';
import {useAppDispatch} from '../../store/hooks';
import {
  setAuctionWallet,
  setBidWallet,
  setPayWallet,
} from '../../store/slices/auction';
import {useMutation} from 'react-query';

export function MetamaskAccountsButton({
  type,
}: {
  type: 'bid' | 'sell' | 'pay';
}) {
  const dispatch = useAppDispatch();
  const getWallets = useMutation(async () => {
    const accounts = await requestAccounts();
    console.info('accounts');
    if (type === 'bid') dispatch(setBidWallet(accounts[0]));
    if (type === 'sell') dispatch(setAuctionWallet(accounts[0]));
    if (type === 'pay') dispatch(setPayWallet(accounts[0]));
  });
  return (
    <Button
      icon={'wallet'}
      mode="outlined"
      onPress={() => getWallets.mutateAsync()}>
      Show Metamask Wallets
    </Button>
  );
}
